import { render } from "./TripDetails.vue?vue&type=template&id=3b5f1924&scoped=true"
import script from "./TripDetails.vue?vue&type=script&lang=js"
export * from "./TripDetails.vue?vue&type=script&lang=js"

import "./TripDetails.vue?vue&type=style&index=0&id=3b5f1924&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5f1924"]])

export default __exports__